"use client";

import type { ReactNode } from "react";

import Image from "next/image";

import { brandName } from "@/src/app/metadata";

export default function GlobalError({
  error,
}: {
  readonly error: { digest?: string } & Error;
}): ReactNode {
  return (
    <html>
      <body style={{ margin: 0 }}>
        <nav
          style={{
            alignItems: "center",
            backgroundColor: "#0077c8",
            display: "flex",
            height: "3.5rem",
          }}
        >
          <a href="/" style={{ paddingInline: "0.74rem" }}>
            <Image
              alt={brandName}
              height={34}
              priority
              src="/logos/cqlp-white-inline.svg"
              width={133}
            />
          </a>
        </nav>
        <header style={{ paddingTop: "4rem", textAlign: "center" }}>
          <h1>⚙️ Problème technique</h1>
        </header>
        <main style={{ textAlign: "center" }}>
          <p>Merci pour votre patience, nous revenons bientôt…</p>
          {error.digest ? (
            <p>Envoyez-nous ce code d’erreur : {error.digest}</p>
          ) : null}
        </main>
      </body>
    </html>
  );
}
